var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12FBC43B-46D1-484C-AAF9-0A047BB58370") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-608.000000, -3215.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(127.000000, 3160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/confirmed",
    transform: "translate(481.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,4 C16.41125,4 20,7.58875 20,12 C20,16.41125 16.41125,20 12,20 C7.58875,20 4,16.41125 4,12 C4,7.58875 7.58875,4 12,4 Z M12,5 C8.14026957,5 5,8.14030221 5,12 C5,15.8599589 8.14030221,19 12,19 C15.8599262,19 19,15.8599262 19,12 C19,8.14026957 15.8599262,5 12,5 Z M14.3085469,10.0092891 C14.5036172,9.82410938 14.8115625,9.8326875 14.9962734,10.0274531 C15.1812891,10.2223828 15.1730391,10.5303281 14.9781328,10.7152031 L14.9781328,10.7152031 L11.5240781,13.990875 C11.4298594,14.0798906 11.3095312,14.1243281 11.1892031,14.1243281 C11.0623828,14.1243281 10.9358906,14.0750391 10.8407109,13.9772578 L10.8407109,13.9772578 L9.02449219,12.1125469 C8.83703906,11.9200547 8.84109375,11.6121094 9.03358594,11.4246563 C9.22624219,11.2370156 9.53385937,11.2412344 9.72147656,11.4337266 L9.72147656,11.4337266 L11.2028203,12.9546563 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/confirmed.1bae9a21.svg";
export { ForwardRef as ReactComponent };